// frontend/src/engine/app/offsite-context.tsx
import { createContext, useContext, useEffect, type ReactNode } from "react";
import { assertOffsiteConfig, type OffsiteConfig } from "./offsite-config";

const Ctx = createContext<OffsiteConfig | null>(null);

export function OffsiteConfigProvider({
  config,
  children,
}: {
  config: OffsiteConfig;
  children: ReactNode;
}) {
  assertOffsiteConfig(config);
  // index.html trägt fest "SVO Offsite 2026" — im Browser-Tab der Gäste
  // sichtbar, und bei einer Gremien-Sitzung schlicht falsch.
  useEffect(() => {
    document.title = config.displayName;
  }, [config.displayName]);
  return <Ctx.Provider value={config}>{children}</Ctx.Provider>;
}

export function useOffsiteConfig(): OffsiteConfig {
  const c = useContext(Ctx);
  if (!c) throw new Error("useOffsiteConfig muss innerhalb von OffsiteConfigProvider stehen");
  return c;
}
